import { render, staticRenderFns } from "./OrderListDeliverying.vue?vue&type=template&id=837ec130&scoped=true"
import script from "./OrderListDeliverying.vue?vue&type=script&lang=js"
export * from "./OrderListDeliverying.vue?vue&type=script&lang=js"
import style0 from "./OrderListDeliverying.vue?vue&type=style&index=0&id=837ec130&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "837ec130",
  null
  
)

export default component.exports